<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Acompanhante</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">

      <div class="p-6">
        <!-- Name -->
        <vs-input name="name" v-model="name" label-placeholder="* Nome completo" class="mt-5 w-full" v-validate="'required'" icon-pack="feather" icon="icon-clipboard"/>
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <!-- Email -->
        <vs-input name="email" v-model="email" label-placeholder="Email" class="mt-5 w-full" v-validate="'email'" icon-pack="feather" icon="icon-mail"/>
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <!-- Cpf -->
        <vs-input  name="cpf" v-model="cpf" label-placeholder="CPF" class="mt-5 w-full" v-validate="'digits:11'" icon-pack="feather" icon="icon-clipboard"/>
        <span class="text-danger text-sm" v-show="errors.has('cpf')">{{ errors.first('cpf') }}</span>

        <!-- PhoneNumber -->
        <vs-input  name="phoneNumber" v-model="phoneNumber" label-placeholder="Telefone" class="mt-5 w-full" icon-pack="feather" icon="icon-smartphone"/>

        <div class="my-4">
          <p class="label">* (Campo obrigatório)</p>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitForm">Enviar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Validator } from 'vee-validate';
import CompanionService from "../../../services/CompanionService";

const dict = {
  custom: {
    name: {
      required: 'Informe o nome completo.',
    },
    email: {
      email: 'Informe um email válido.'
    }
  }
};

Validator.localize('en', dict);
export default {
  name: 'companion-form',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      name: '',
      cpf: '',
      email: '',
      phoneNumber: '',
      //Config
      notifications: 
      {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar');
          this.initValues();
        }
      }
    }
  },
  methods: {
    async submitForm() {
     this.$validator.validateAll().then(result => {
        if (result) {
          this.createCompanion();
        } else {
          // form have errors
        }
      })
    },
    async createCompanion() {
      this.$vs.loading();

      var payload = {
        data: {
          name: this.name,
          cpf: this.cpf,
          email: this.email,
          phoneNumber: this.phoneNumber,
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;

      var result = await CompanionService.create(payload);

      if(result.status == 200) {
        this.initValues();
        this.$emit('closeSidebar');
      }

      this.$vs.loading.close();
    },
    toDate (dateStr) {
      const [day, month, year] = dateStr.split("/");
      return new Date(year, month - 1, day);
    },
    initValues() {
      this.name = '';
      this.cpf = '';
      this.email = '';
      this.phoneNumber = '';
    }
  },
  components: {
    VuePerfectScrollbar,
    flatPickr,
    CompanionService
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52004;
  }

  /deep/ .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.label {
  padding-left: 5px;
  font-size: .85rem;
  color: rgba(0,0,0,.7);
  margin-bottom: 2px;
}

.datetime-picker {
  width: 100%;
}
</style>